<template>
  <v-dialog
    v-if="loggedIn && tokenWillExpireSoon"
    :value="true"
    width="500"
    persistent
  >
    <v-card>
      <AdCardTitle>{{ $t('access-token-almost-expired')}}</AdCardTitle>
      <v-card-text class="pa-5">{{ $t('stay-logged-in')}}</v-card-text>
      <v-card-actions class="dialogbottomstrip">
        <v-spacer/>
        <AdButton type="cancel" @click="logout">{{ $t('logout')}}</AdButton>
        <AdButton color="orange" :text="$t('confirm-with-credentials')" @click="$emit('needCredentials')"/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const INTERVAL = 60 * 1000 // Check if token expires every ... ms
const OFFSET = +process.env.VUE_APP_TOKEN_EXPIRATION_CHECK_OFFSET || 5 * 60 * 1000 // Time (ms) before expiration the dialog should show up

export default {
  data () {
    return {
      timer: null,
      tokenWillExpireSoon: false
    }
  },

  computed: {
    loggedIn () {
      return this.$store.getters['authentication/isUserLoggedIn']
    }

  },

  methods: {
    checkTokenExpiration () {
      const expires = new Date(this.$store.state.authentication.tokenExpires).getTime()
      const now = Date.now()
      const diff = expires - now
      if (diff <= 0) {
        this.logout()
        return
      }
      if (diff < OFFSET) {
        this.tokenWillExpireSoon = true
        return
      }
      this.tokenWillExpireSoon = false
    },
    logout () {
      this.$store.dispatch('authentication/clearTokenData')
    }
  },

  watch: {
    loggedIn: {
      immediate: true,
      handler (isLoggedIn) {
        if (isLoggedIn) {
          this.timer = setInterval(() => {
            this.checkTokenExpiration()
          }, INTERVAL)
        } else {
          clearInterval(this.timer)
          this.tokenWillExpireSoon = false
        }
      }
    }
  }
}
</script>
